export const STUDIO_STRINGS = {
  en: {
    SHOW_LESS: 'Show less',
    READ_MORE: 'Read more',
    FACILITIES: 'Facilities',
    OPENING_HOURS: 'Opening hours',
    CLASSES: 'Classes',
    TODAY: 'Today',
    NO_CLASSES: 'No classes today',
    SEE_IN_APP: 'See all classes in the app',
    REVIEWS: 'Reviews',
    LOCATION: 'Location',
    DIRECTIONS: 'Directions',
    EXPLORE: 'Explore new studios in',
  },
  sv: {
    SHOW_LESS: 'Visa mindre',
    READ_MORE: 'Läs mer',
    FACILITIES: 'Faciliteter',
    OPENING_HOURS: 'Öppet för egen träning',
    CLASSES: 'Pass',
    TODAY: 'Idag',
    NO_CLASSES: 'Inga pass idag',
    SEE_IN_APP: 'Se alla pass i appen',
    REVIEWS: 'Kundbetyg',
    LOCATION: 'Adress',
    DIRECTIONS: 'Vägbeskrivning',
    EXPLORE: 'Utforska nya studios i',
  },
  nb: {
    SHOW_LESS: 'Vis mindre',
    READ_MORE: 'Les mer',
    FACILITIES: 'Fasiliteter',
    OPENING_HOURS: 'Åpningstider egentrening',
    CLASSES: 'Gruppetimer',
    TODAY: 'I dag',
    NO_CLASSES: 'Ingen timer i dag',
    SEE_IN_APP: 'Se alle timer i appen',
    REVIEWS: 'Anmeldelser',
    LOCATION: 'Lokasjon',
    DIRECTIONS: 'Veibeskrivelse',
    EXPLORE: 'Utforsk nye studios i',
  },
  da: {
    SHOW_LESS: 'Vis mindre',
    READ_MORE: 'Læs mere',
    FACILITIES: 'Faciliteter',
    OPENING_HOURS: 'Åbningstider',
    CLASSES: 'Hold',
    TODAY: 'I dag',
    NO_CLASSES: 'Ingen pas i dag',
    SEE_IN_APP: 'Se alle pas i appen',
    REVIEWS: 'Anmeldelser',
    LOCATION: 'Adresse',
    DIRECTIONS: 'Rutevejledning',
    EXPLORE: 'Opdag nye studios i',
  },
} as const
